<template>
    <div
        class="relative"
        ref="wrapper"
    >
        <label
            class="select-filter"
            :class="{
                'select-filter-active': active,
            }"
            @click="toggle"
        >
            <p class="label label-small">
                Who
            </p>

            <p class="select-filter-note">
                <template v-if="selected">
                    {{ countAsText }}
                </template>
                <template v-else>
                    Add venue capacity
                </template>
            </p>
        </label>

        <DeleteButton
            v-if="selected"
            class="absolute top-1/2 right-3 xl:right-5 -translate-y-1/2"
            @click.prevent="clear"
        />

        <Transition>
            <Dropdown
                class="w-full"
                title="Select"
                placement="sm-left"
                v-model:active="active"
                @close="active = false"
            >
                <div
                    class="space-y-3 sm:space-y-5 [&>div:not(:last-child)]:pb-3 sm:[&>div:not(:last-child)]:pb-5 divide-y divide-brand-2-950/10"
                    :class="{ 'opacity-60 pointer-events-none': loading }"
                >
                    <NumberFilter
                        label="Venue capacity"
                        name="capacity"
                        v-model:value.number="count.capacity"
                    />

                    <NumberFilter
                        label="Seated indoors"
                        name="seated_indoors"
                        v-model:value.number="count.seated_indoors"
                    />
                </div>
            </Dropdown>
        </Transition>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, useTemplateRef, watch } from 'vue';

    import DeleteButton from '@js/src/components/DeleteButton.vue';
    import Dropdown from '@js/src/components/Dropdown.vue';
    import NumberFilter from '@js/src/components/NumberFilter.vue';

    const emit = defineEmits([
        'change',
        'close',
    ]);

    const props = defineProps([
        'loading',
        'capacityCount',
        'seatedIndoorsCount',
    ]);

    const wrapper = useTemplateRef('wrapper');

    const active = ref(false);
    const count = ref({
        capacity: props.capacityCount,
        seated_indoors: props.seatedIndoorsCount,
    });

    const selected = computed(() => {
        return Object.values(count.value)
            .filter(value => value)
            .length > 0;
    });

    // The trigger used to print the raw payload keys ("350 capacity, 30 seated
    // indoors"). Same wording as the fields below it and as the property page.
    const LABELS = {
        capacity: 'venue capacity',
        seated_indoors: 'seated indoors',
    };

    const countAsText = computed(() => {
        return Object.entries(count.value)
            .filter(([key, value]) => value)
            .map(([key, value]) => `${value} ${LABELS[key] ?? key.replaceAll('_', ' ')}`)
            .join(', ');
    });

    watch(() => count, () => {
        emit('change', count.value);
    }, {
        deep: true,
    });

    watch(active, (value) => {
        if (!value) {
            emit('close');
        }
    });

    function toggle() {
        active.value = !active.value;
    }

    function clear() {
        count.value = {
            capacity: 0,
            seated_indoors: 0,
        };

        emit('change', count.value);
        emit('close');
    }

    onMounted(() => {
        window.addEventListener('click', function (e) {
            if (wrapper.value && !wrapper.value.contains(e.target)) {
                active.value = false;
            }
        });
    });
</script>
